export default {
  apiUrl: process.env.NODE_ENV === "development" ?
    "http://localhost/webble/api/" :
    "https://apillc.webble.cz/api/"
}


// WEBPACK FOOTER //
// ./src/constants/config.js